import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPosStore } from '~api/pos';

export const store = createAsyncThunk(
  'pos/store',
  async (params) => await getPosStore(params),
);
